export const MAP_FILTERS = {
  STATE: 'STATE',
  NATIONAL: 'NATIONAL',
  DC: 'DC',
  PR: 'PR',
};
